export default __webpack_public_path__ + "static/mangococonutbarfi-5ea4fdf2f0d08d270e54c069b1101cb3.png";